// @ts-nocheck
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import LoadingOverlay, { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import { TypographyPresentationProps } from "@store/MobiusOverrides/Typography/Typography";
import CardListHeading from "@store/Overrides/Components/CardListHeading";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    currentBillTo: getCurrentBillToState(state).value,
    isLoading: getCurrentBillToState(state).isLoading,
});

type Props = ReturnType<typeof mapStateToProps>;

export interface AccountCustomerNumberStyles {
    customerNumberSection?: InjectableCss;
    loadingOverlay?: LoadingOverlayProps;
    title?: TypographyPresentationProps;
    text?: TypographyPresentationProps;
    wrapper?: InjectableCss;
}

export const accountCustomerNumberStyles: AccountCustomerNumberStyles = {
    wrapper: {
        css: css`
            width: 100%;
            display: flex;
            background-color: #f5f5f5;
            gap: ${pxToRem(10)};
            padding: 1rem;
            border: 1px solid ${getColor("common.border")};
        `,
    },
    loadingOverlay: { minHeight: 80 },
    title: {
        forwardAs: "p",
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    text: {
        forwardAs: "p",
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.base};
        `,
    },
};

const styles = accountCustomerNumberStyles;
const StyledSection = getStyledWrapper("section");

const AccountCustomerNumber: React.FunctionComponent<Props> = (props: Props) => {
    const { currentBillTo, isLoading } = props;
    const hasNoResults = currentBillTo?.customerNumber === undefined;

    return (
        <StyledSection {...styles.customerNumberSection} data-test-selector="myAccount_customerNumberSection">
            <CardListHeading heading={`${translate("Current Bill To")}`} hasNoResults={true} />
            <LoadingOverlay {...styles.loadingOverlay} loading={isLoading}>
                {currentBillTo?.customerNumber && (
                    <StyledWrapper {...styles.wrapper}>
                        <Typography {...styles.title}>{translate("Customer Number")}: </Typography>
                        <Typography {...styles.text}>{currentBillTo.customerNumber}</Typography>
                    </StyledWrapper>
                )}
            </LoadingOverlay>
        </StyledSection>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(AccountCustomerNumber),
    definition: {
        allowedContexts: ["MyAccountPage"],
        group: "My Account",
    },
};

export default widgetModule;
